import React from "react";
import { Button, Col, List, Row } from "antd";
import { TCaseLawDocumentPresentationModel } from "../../presenter/model/CaseLawDocumentPresentationModel";

import { PlusOutlined } from "@ant-design/icons";
import Title from "antd/lib/typography/Title";
import CaseLawDocumentListItem from "./CaseLawDocumentListItem";
import Text from "antd/lib/typography/Text";
import { IUser } from "../../../user/model/User";
export interface CaseLawDocumentListProps {
  translate: any;
  loaders: any;
  caseLawDocumentList: TCaseLawDocumentPresentationModel[];
  createNewCaseLawDocument?: () => void;
  showCaseLawDocumentDetails(id: number): void;
  user?: IUser;
  showSearchResult: boolean;
}
const CaseLawDocumentList: React.FC<CaseLawDocumentListProps> = (
  props: CaseLawDocumentListProps
) => {
  const {
    translate,
    caseLawDocumentList,
    createNewCaseLawDocument,
    showCaseLawDocumentDetails,
    user,
    showSearchResult
  } = props;
  return (
    <div>
      {!showSearchResult && (
        <div>
          <Row className={"search-result"}>
            <Col xs={24} sm={24}>
              <Title level={4}>
                {translate("editors.case_law_documents.create_modal_title")}
              </Title>
              <Text>Prikazani su svi unosi.</Text>
            </Col>
          </Row>
          <Row
            className={"datagrid-header"}
            style={user?.isUser() ? { display: "none" } : {}}
          >
            <Col
              sm={24}
              style={
                user?.isUser()
                  ? { display: "none" }
                  : { textAlign: "right", paddingTop: 20 }
              }
            >
              <Button
                style={{ textAlign: "right" }}
                className="datagrid-add-btn"
                type={"primary"}
                icon={<PlusOutlined />}
                onClick={() =>
                  createNewCaseLawDocument && createNewCaseLawDocument()
                }
              >
                {translate("editors.case_law_documents.add_new_text")}
              </Button>
            </Col>
          </Row>
        </div>
      )}
      <List
        size="large"
        locale={{
          emptyText: translate("data_grid.empty_text")
        }}
        pagination={{
          hideOnSinglePage: caseLawDocumentList.length < 10,
          pageSize: 10,
          showSizeChanger: true,
          total: caseLawDocumentList.length,
          position: "top",
          showTotal: (total, range) => (
            <Text style={{ position: "absolute", left: 0 }}>{`${translate(
              "data_grid.pagination.showing"
            )} ${range[0]} ${translate("data_grid.pagination.to")} ${
              range[1]
            } ${translate("data_grid.pagination.total")} ${total}`}</Text>
          )
        }}
        dataSource={caseLawDocumentList}
        renderItem={(item) => (
          <CaseLawDocumentListItem
            item={item}
            translate={translate}
            showCaseLawDocumentDetails={showCaseLawDocumentDetails}
          />
        )}
      />
    </div>
  );
};
export default CaseLawDocumentList;
